import parseAppKey from "../routeHelpers/parseAppKey";
import PutItem from "../dataProviders/putItem";

const setLock = async lockStatus => {
	const appKey = parseAppKey();
	const { globalIsLocked, appIsLocked } = lockStatus;
	if (!globalIsLocked) {
		try {
			await PutItem(`/apps/${appKey}/lock`, { isLocked: !appIsLocked });
			return true;
		} catch (error) {
			console.error(error);
			return false;
		}
	} else {
		return Promise.resolve(false);
	}
};

export default setLock;
